const djangoURL = 'https://admin.myweberacademy.com/'

export default djangoURL